"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const QuantityPickerWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: right;
  margin-left: auto;
  width: 50%;
`;
const ChangeQuantityButton = styled_components_1.default.div `
  cursor: pointer;
  flex-basis: 30px;
  border: 1px solid rgb(217, 217, 217);
  border-radius: 4px;
  text-align: center;
  user-select: none;
`;
const Quantity = styled_components_1.default.div `
  flex-basis: 20%;
  min-width: 30px;
  text-align: center;
`;
const QuantityPicker = (props) => {
    const { item, onChange, itemIndex } = props;
    const [quantity, setQuantity] = (0, react_1.useState)(1);
    const increaseQuantity = () => {
        setQuantity(quantity + 1);
        onChange(item, quantity + 1, itemIndex);
    };
    const decreaseQuantity = () => {
        if (quantity > 1) {
            setQuantity(quantity - 1);
        }
        onChange(item, quantity - 1, itemIndex);
    };
    (0, react_1.useEffect)(() => {
        if (typeof props.item.quantity === "number") {
            setQuantity(props.item.quantity);
        }
    }, []);
    return (react_1.default.createElement(QuantityPickerWrapper, null,
        react_1.default.createElement(ChangeQuantityButton, { onClick: decreaseQuantity }, "-"),
        react_1.default.createElement(Quantity, null, quantity),
        react_1.default.createElement(ChangeQuantityButton, { onClick: increaseQuantity }, "+")));
};
exports.default = QuantityPicker;
